/* eslint-disable no-unused-vars */
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { TIME } from 'app-webtech-core/helpers/time';
import { APP_LAUNCH_TRACK } from './types';
import { Joi } from '../../../schemas';

const schema = Joi.object().keys({
  seconds: Joi.number().required(),
});

const action = actionCreator(APP_LAUNCH_TRACK, schema);

let intervalHandler;
let alreadyStarted = false;

export const appLaunchTrackThunkAction = (stop = false) => (dispatch) => {
  if (stop) {
    // if called twice, clearInterval silently does nothing; no exception is thrown.
    clearInterval(intervalHandler);
    intervalHandler = undefined;
    return;
  }
  if (alreadyStarted) {
    console.warn('APP_LAUNCH_TRACK already started. Ignoring request.');
    return;
  }
  alreadyStarted = true;
  let seconds = 0;
  intervalHandler = setInterval(() => {
    // dispatch(action({ seconds }));
    seconds += 1;
  }, TIME.ONE_SEC_IN_MS);
};
